if (!customElements.get("products-slider")) {
  customElements.define(
    "products-slider",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          swiper: this.querySelector(".products-slider__swiper")
        };

        const swiper = new Swiper(".products-slider__swiper", {
          // Optional parameters
          slidesPerView: 1.15,
          spaceBetween: 8,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,

          // If we need pagination
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
          // Navigation arrows
          //   navigation: {
          //     nextEl: ".swiper-button-next",
          //     prevEl: ".swiper-button-prev",
          //   },
        });
      }
    }
  );
}
